import axios from 'axios'

// ACTIONS
export const SET_OPTIONS = 'SET_OPTIONS'
export const SELECT_LOCATION = 'SELECT_LOCATION'
export const SELECT_DIAL = 'SELECT_DIAL'
export const SET_CAMPAIGN = 'SET_CAMPAIGN'
export const AUTH_ERROR = 'AUTH_ERROR'

export function initOptions() {
  return (dispatch, getState) => {
    const campaignId = getState().get('scheduling').get('options').get('campaignId')
    const token = getState().get('scheduling').get('options').get('token')

    return new Promise((resolve) =>
      axios({
        method: 'get',
        url: `/hackersmindcampaigns/${campaignId}/scheduled_sessions_settings/`,
        headers: {
          Authorization: `${token}`
        }
      })
        .then((res) => {
          if (res.status === 200) {
            dispatch({
              type: SET_OPTIONS,
              data: res.data
            })

            resolve()
          }
        })
        .catch((err) =>
          dispatch({
            type: AUTH_ERROR,
            data: err.response.data
          })
        )
    )
  }
}

export function setLocation(location = '') {
  return (dispatch) => {
    let _location = location
    if (_location === 'Please select') _location = ''

    dispatch({
      type: SELECT_LOCATION,
      data: _location
    })
  }
}

export function setDial(dial = '') {
  return (dispatch) => {
    let _dial = dial
    if (_dial === 'Please select') _dial = ''

    dispatch({
      type: SELECT_DIAL,
      data: _dial
    })
  }
}
